<template>
  <header class="header">
    <div class="navbar">
      <div class="container">
        <div class="navbar-brand">
          <router-link :to="{ name: 'home' }" class="navbar-item">
            <img src="../assets/logo.png" srcset="../assets/logo@2x.png 2x" alt="เสพย์สากล">
          </router-link>
          <a
            role="button"
            class="navbar-burger"
            :class="{'is-active': openMenu}"
            aria-label="menu"
            aria-expanded="false"
            @click="toggleMenu"
          >
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
        </div>
        <div class="navbar-menu" :class="{'is-active': openMenu}">
          <div class="navbar-start">
            <router-link class="navbar-item" :to="{ name: 'home' }">
              Dashboard
            </router-link>
            <router-link class="navbar-item" :to="{ name: 'banner' }">
              Banner
            </router-link>
            <router-link class="navbar-item" :to="{ name: 'article' }">
              Article
            </router-link>
            <router-link class="navbar-item" :to="{ name: 'menu' }">
              Menu
            </router-link>
            <div class="navbar-item has-dropdown is-hoverable">
              <a class="navbar-link">
                Settings
              </a>
              <div class="navbar-dropdown">
                <router-link class="navbar-item" :to="{ name: 'setting.seo' }">
                  SEO
                </router-link>
              </div>
            </div>
          </div>
          <div class="navbar-end">
            <a class="navbar-item" @click="onLogout">
              Logout
            </a>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      openMenu: false,
    };
  },
  methods: {
    ...mapActions('auth', ['logout']),
    toggleMenu() {
      this.openMenu = !this.openMenu;
    },
    onLogout() {
      this.logout().finally(() => {
        this.$router.push({ name: 'login' });
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.navbar-brand
  img
    height: 1.75rem
</style>
